// Asset/source search terms are sent inside the GET query string (see
// getAssetFilters/getSourceFilters). The server rejects a request whose headers
// exceed 16KB, and the select modal used to close on that failure. Guard both
// the item count and the encoded length so an oversized list gets a friendly
// message instead of a doomed request.
export const MAX_SEARCH_TERMS = 500;
const MAX_SEARCH_QUERY_LENGTH = 12000;

// Mirrors EXACT_SEARCH_TERM_THRESHOLD on the API: past this many terms the
// search matches whole values instead of fragments, which is what keeps a
// several-hundred-item list fast.
export const EXACT_SEARCH_TERM_THRESHOLD = 25;

export const SEARCH_LIMIT_MESSAGE = `You can search up to ${MAX_SEARCH_TERMS} items at a time. Please shorten your list.`;
export const SEARCH_LENGTH_MESSAGE =
  'Your search list is too long. Please search in smaller batches.';
export const EXACT_SEARCH_HINT = `Lists longer than ${EXACT_SEARCH_TERM_THRESHOLD} items are matched exactly, so enter complete ids or names.`;

// Lists get pasted in from spreadsheets, so accept the separators those produce
// (new line, tab, semicolon) alongside the comma users type by hand.
export const parseSearchTerms = (textStr) =>
  textStr?.length
    ? textStr
        .split(/[,;\t\r\n]+/)
        .map((v) => v.trim())
        .filter((v) => v.length)
    : [];

// A single-line input drops line breaks from its value, which would glue a
// pasted spreadsheet column into one unusable term. Turn the breaks into the
// separator the field already understands.
export const normalizePastedSearch = (text) => text.replace(/[\t\r\n]+/g, ',');

export const getSearchError = (terms) => {
  if (terms.length > MAX_SEARCH_TERMS) {
    return SEARCH_LIMIT_MESSAGE;
  }

  if (
    encodeURIComponent(JSON.stringify(terms)).length > MAX_SEARCH_QUERY_LENGTH
  ) {
    return SEARCH_LENGTH_MESSAGE;
  }

  return null;
};

export const isExactSearch = (terms) =>
  terms.length > EXACT_SEARCH_TERM_THRESHOLD;
